import { AxiosResponse } from "axios";
import { axiosInstance, MessageResponse } from "./common";

export interface GetSCNResponseParams {
    report_id?: string;
}

export interface SCNResponseReport {
    report_id: string;
    party_id: string;
    is_response_received: boolean;
    file_reference?: string;
    file_name?: string;
    status?: string;
    last_updated_at: string;
}

export interface SCNResponseReportsResponse {
    responses: SCNResponseReport[];
}

export interface PutSCNResponseLegacyRequest {
    case_id: string;
    report_id: string;
    party_id: string;
    is_response_received: boolean;
    file?: File;
}

export interface PutSCNResponseRequest {
    party_id: string;
    is_response_received: boolean;
}

export const SCNResponseLegacyAPI = {
    get_scn_response: async (
        { case_id, report_id }: { case_id: string } & GetSCNResponseParams
    ) => {
        const response: AxiosResponse<SCNResponseReportsResponse> =
            await axiosInstance.get(
                `v1/cases/${case_id}/reports/scn-response`,
                report_id ? { params: { report_id } } : undefined
            );

        return response.data;
    },

    put_scn_response: async ({
        case_id,
        report_id,
        party_id,
        is_response_received,
        file,
    }: PutSCNResponseLegacyRequest): Promise<MessageResponse> => {
        const formData = new FormData();
        formData.append("party_id", party_id);
        formData.append("is_response_received", is_response_received.toString());

        if (file) {
            formData.append("file", file);
        }

        const response: AxiosResponse<MessageResponse> =
            await axiosInstance.put(
                `v1/cases/${case_id}/reports/scn-response/${report_id}`,
                formData,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );

        return response.data;
    },
};

export const SCNResponseAPI = {
    get_scn_response_reports: async (
        { case_id, report_id }: { case_id: string } & GetSCNResponseParams
    ): Promise<SCNResponseReportsResponse> => {
        const response: AxiosResponse<SCNResponseReportsResponse> =
            await axiosInstance.get(
                `v1/cases/${case_id}/scn-response-reports`,
                report_id ? { params: { report_id } } : undefined
            );
        return response.data;
    },

    put_scn_response_report: async (
        case_id: string,
        report_id: string,
        request: PutSCNResponseRequest
    ): Promise<MessageResponse> => {
        const response: AxiosResponse<MessageResponse> =
            await axiosInstance.put(
                `v1/cases/${case_id}/scn-response-reports/${report_id}`,
                request
            );
        return response.data;
    },
};